export const FloorplanSmsFormController = ['$scope', '$http', 'modalFactory', function(scope, $http, $modal) {

    scope.phoneNumber = null;

    scope.submit = function(valid){
        if(valid){
            $http({
                method: 'POST',
                url: '/wp-json/richman/v1/floorplanSMS',
                data: {
                    floorplanURL: scope.floorplanURL,
                    phone: scope.phoneNumber
                }
            }).then(function successCallback() {

            }, function errorCallback() {

            });
            $modal.close(); 
        }
    };
}];